export default "__VITE_ASSET__CZ7w3Heg__"